<template>
	<LayoutMain>
		<div class="navsecondary">
			<RouterLink data-ic="V" :to="{ name: 'PersonsImport', params: { customerid: this.$route.params.customerid }}">
				<span>Importer</span>
			</RouterLink>

			<a href="#" v-if="agreementID" data-ic="U" :class="{ 'active' : navtoolsgeneratefiles }" @click.prevent="toggleNavTools('generatefiles')">
				<span>Generer filer</span>
			</a>

			<a href="#" data-ic="O" :class="{ 'active' : navtoolscreate }" @click.prevent="toggleNavTools('create')">
				<span>Opret</span>
			</a>

			<input type="search" v-model="searchinput" /><i data-ic="Q"></i>
		</div>

		<transition name="fade">
			<div class="navtools" ref="navtools-generatefiles" v-if="navtoolsgeneratefiles">
				<RouterLink data-ic="U" :to="{ name: 'GeneratePDFs', params: { customerid: this.$route.params.customerid, agreementid: this.$route.params.agreementid }}">
					<span>Generer PDF</span>
				</RouterLink>

				<a href="#" data-ic="5" @click.prevent="generateLowResImages">
					<span>Low-res billeder</span>
				</a>

				<a href="#" data-ic="4" @click.prevent="generateEmailFile">
					<span>E-mail adresser</span>
				</a>

				<a href="#" data-ic="E" @click.prevent="generateOrdersDetails">
					<span>Bestillinger</span>
				</a>

				<a href="#" data-ic="E" @click.prevent="generateOrdersDeliveryNotes">
					<span>Følgesedler</span>
				</a>
			</div>
		</transition>

		<transition name="fade">
			<div class="navtools" ref="navtools-create" v-if="navtoolscreate">
				<RouterLink data-ic="M" :to="{ name: 'AgreementCreate', params: { customerid: this.$route.params.customerid }}">
					<span>Opret aftale</span>
				</RouterLink>

				<RouterLink data-ic="O" :to="{ name: 'PersonGroupCreate', params: { customerid: this.$route.params.customerid }}" v-if="agreementChosen">
					<span>Opret gruppe</span>
				</RouterLink>

				<RouterLink data-ic="O" :to="{ name: 'PersonCreate', params: { customerid: this.$route.params.customerid }}" v-if="agreementChosen">
					<span>Opret person</span>
				</RouterLink>
			</div>
		</transition>

		<section>
			<h1 ref="pagetitle"></h1>

			<div>
				<transition name="fade">
					<RouterView v-bind:search="searchinput" v-bind:customer="customer" v-bind:section="'customer'" />
				</transition>
			</div>
		</section>

	</LayoutMain>
</template>

<script>
	import { types } from "@/app/types/types"
	import { appFeedbackStateEnum } from "@/app/enums/common"
	import LayoutMain from "@/components/common/LayoutMain.vue"

	export default {
		name: "CustomerShow",
		data()
		{
			return {
				customer: null,
				customerID: 0,
				agreementID: 0,
				agreement: null,
				navtoolsgeneratefiles: false,
				navtoolscreate: false,
				searchinput: ""
			}
		},
		beforeMount()
		{
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid

			if (this.agreementID == undefined)
			{
				this.agreementID = 0
			}

			this.loadData()
		},
		watch:
		{
			"$route": "loadData"
		},
		beforeRouteUpdate(to, from, next)
		{
			this.toggleNavTools()
			next()
		},
		methods:
		{
			async generateOrdersDeliveryNotes()
			{
				var data = { customerid: this.customerID, agreementid: this.agreementID }
				var result = await this.$store.dispatch(types.ACTION_EXPORT_ORDERS_DELIVERYNOTES, data)

				this.toggleNavTools(false)

				if (result.status == 200)
				{
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("CustomerShow.generateOrdersDeliveryNotes()", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.")
				}
			},
			async generateOrdersDetails()
			{
				var data = { customerid: this.customerID, agreementid: this.agreementID }
				var result = await this.$store.dispatch(types.ACTION_EXPORT_ORDERS_DETAILS, data);

				this.toggleNavTools(false)

				if (result.status == 200)
				{
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("CustomerShow.generateOrdersDetails()", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.");
				}
			},
			async generateLowResImages()
			{
				var data = { customerid: this.customerID, agreementid: this.agreementID }
				var result = await this.$store.dispatch(types.ACTION_EXPORT_LOWRES_IMAGES, data);

				this.toggleNavTools(false)

				if (result.status == 200)
				{
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("CustomerShow.generateLowResImages()", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.");
				}
			},
			async generateEmailFile()
			{
				var data = { customerid: this.customerID, agreementid: this.agreementID }
				var result = await this.$store.dispatch(types.ACTION_EXPORT_EMAILS, data);

				this.toggleNavTools(false)

				if (result.status == 200)
				{
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("CustomerShow.generateEmailFile()", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.");
				}
			},
			async getAgreement()
			{
				var agreementResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENT, this.agreementID)

				if (agreementResult.status == 200)
				{
					this.agreement = agreementResult.data

					if (this.agreement)
					{
						this.$refs.pagetitle.innerText = this.customer.name + ", " + this.agreement.name
					}

					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("CustomerShow.loadData() getAgreements", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.$router.push({ name: "CustomerShow" })
				}
			},
			toggleNavTools(container)
			{
				if (!container)
				{
					this.navtoolscreate = false
					this.navtoolsgeneratefiles = false
					return
				}

				switch (container)
				{
					case "generatefiles":
						this.navtoolsgeneratefiles = !this.navtoolsgeneratefiles
						this.navtoolscreate = false
						break
					case "create":
						this.navtoolsgeneratefiles = false
						this.navtoolscreate = !this.navtoolscreate;
						break
				}
			},
			async loadData()
			{
				if (this.customerID)
				{
					this.setAppAsBusyModal();

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID);

						if (result.status == 200)
						{
							this.customer = result.data;
							this.$refs.pagetitle.innerText = this.customer.name
							this.setAppAsIdle()

							if (this.agreementID == undefined || this.agreementID == 0)
							{
								this.agreementID = this.$route.params.agreementid
							}

							if (this.agreementID != undefined && this.agreementID != 0)
							{
								this.getAgreement()
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("CustomerShow.loadData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
							this.$router.push({ name: "Customers" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("CustomerShow.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "Customers" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 7");
					this.$router.push({ name: "Customers" })
				}
			},
			close()
			{
				this.$router.push({ name: "Customers" })
			}
		},
		computed:
		{
			agreementChosen()
			{
				return this.agreementID && this.agreementID != 0
			},
			isEditOpen()
			{
				return this.$route.name === "CustomerEdit"
			},
			isCreateOpen()
			{
				return this.$route.name === "CustomerCreate"
			}
		},
		components: {
			LayoutMain
		}
	};
</script>